import {createFileRoute, redirect} from '@tanstack/react-router'

// Public sign-up is off (see server/src/lib/auth.ts); the path stays valid but only sends to login.
export const Route = createFileRoute('/auth/register')({
  beforeLoad: () => {
    throw redirect({to: '/auth/login'})
  },
})
